"use client";

import { useState, useRef, useEffect } from "react";
import style from "./DegreeProgramListDetails.module.scss";
import cn from "clsx";

const list = [
  {
    id: 1,
    name: "All Courses",
    filterName: "",
  },
  {
    id: 2,
    name: "PG Courses",
    filterName: "PG_Program",
  },
  {
    id: 3,
    name: "UG Courses",
    filterName: "UG_Program",
  },
  {
    id: 4,
    name: "Specializations",
    filterName: "Specialization",
  },
  {
    id: 5,
    name: "Certifications",
    filterName: "Certification",
  },
];

export const CourseCategoryList = ({
  setCourseType,
  courseType,
  isAffiliatePage = false,
  landingPageValue = "",
  isLandingPage = false,
}) => {
  const [isToggleOpen, setIsToggleOpen] = useState(false);
  const toggleRef = useRef(null);

  const isHiddenItem = (item) =>
    (isLandingPage && item?.id === 5) ||
    (landingPageValue === "UG" && item?.id === 2) ||
    (landingPageValue === "PG" && item?.id === 3);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isToggleOpen &&
        toggleRef.current &&
        !toggleRef.current.contains(event.target as Node)
      ) {
        setIsToggleOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isToggleOpen]);

  return (
    <>
      <div className={cn(style.categorylist_container_mobile, "w-full")}>
        <div className={style.dropdownWrapper} ref={toggleRef}>
          <button
            className={style.dropdownTrigger}
            onClick={() => setIsToggleOpen((value) => !value)}
          >
            <span>{courseType?.name}</span>
            <svg
              className={cn(
                style.dropdownChevron,
                isToggleOpen && style.dropdownChevronOpen,
              )}
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 9l6 6 6-6"
                stroke="#65758B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          {isToggleOpen && (
            <div className={style.dropdownMenu}>
              {list?.map((item) => {
                if (isAffiliatePage && (item?.id === 4 || item?.id === 5)) return null;
                if (isHiddenItem(item)) return null;
                return (
                  <button
                    key={item?.id}
                    className={cn(
                      style.dropdownItem,
                      item?.id === courseType?.id && style.dropdownItemActive,
                    )}
                    onClick={() => {
                      setCourseType(item);
                      setIsToggleOpen(false);
                    }}
                  >
                    {item?.name}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
      <div className={style.categorylist_container}>
        {list?.map((item) => {
          if (isHiddenItem(item)) return null;

          if (isAffiliatePage && (item?.id === 4 || item?.id === 5)) {
            return null;
          }

          return (
            <button
              key={item?.id}
              className={cn(
                { [style.active]: item?.id === courseType?.id },
                style.filter_btn,
              )}
              onClick={() => setCourseType(item)}
              id={`degree-list-${item.id}`}
            >
              {item?.name}
            </button>
          );
        })}
      </div>
    </>
  );
};
